import { render, staticRenderFns } from "./addreturnpurchase.vue?vue&type=template&id=10415c42&scoped=true&"
import script from "./addreturnpurchase.vue?vue&type=script&lang=js&"
export * from "./addreturnpurchase.vue?vue&type=script&lang=js&"
import style0 from "./addreturnpurchase.vue?vue&type=style&index=0&id=10415c42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10415c42",
  null
  
)

export default component.exports